import { render, staticRenderFns } from "./traffic-count.vue?vue&type=template&id=60874daa&"
import script from "./traffic-count.vue?vue&type=script&lang=js&"
export * from "./traffic-count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports